import LenisScroll from "@/components/site/LenisScroll";
import LoadingScreen from "@/components/site/LoadingScreen";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import DestinationMarquee from "@/components/site/Marquee";
import WhyChooseUs from "@/components/site/WhyChooseUs";
import Services from "@/components/site/Services";
import Fleet from "@/components/site/Fleet";
import TourPackages from "@/components/site/TourPackages";
import PopularRoutes from "@/components/site/PopularRoutes";
import Counters from "@/components/site/Counters";
import Reviews from "@/components/site/Reviews";
import Gallery from "@/components/site/Gallery";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import FloatingActions from "@/components/site/FloatingActions";

export default function Home() {
  return (
    <div className="relative bg-brand-cream" data-testid="home-page">
      <LenisScroll />
      <LoadingScreen />
      <Header />
      <main>
        <Hero />
        <DestinationMarquee />
        <WhyChooseUs />
        <Services />
        <Fleet />
        <TourPackages />
        <PopularRoutes />
        <Counters />
        <Reviews />
        <Gallery />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
